import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { employeeFields } from 'src/app/modules/campaign/campaign';
import { ApiService } from 'src/app/Services/api.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { MapService } from 'src/app/Services/map.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'g10-campaign-add-employee',
  templateUrl: './campaign-add-employee.component.html',
  styleUrls: ['./campaign-add-employee.component.css']
})
export class CampaignAddEmployeeComponent implements OnInit {

  @Input() selectedRefId: any = {};

  @Output() result: any = new EventEmitter();
  @Output() selectedEmployee: any = new EventEmitter();

  public selectedMemberView:boolean = false;

  public userData;

  public fieldLists = employeeFields;
  recordRefId = 'employeeID';
  public searchEmployees = {};
  public searchFields = [];

  public mapSearchDataLists = [];
  public mapSearchDebounceTimeOut = null;

  apiQueue: boolean = false;
  page: number = 1;
  memberArray = [];
  selectedRecords = {};
  selectAllCheckbox: boolean = false;

  noRecords: boolean = false;

  constructor( public mapService: MapService,  
    public storage: StorageService,
    public api: ApiService,
    private loader: LoaderService
) {
    this.loader.show();
    this.userData = this.storage.get('userInfo');
}

ngOnInit(): void {
  setTimeout(() => {
      this.getMemberInfo();
  }, 1000);
  }

  getFieldList() {
    this.apiQueue = true;
    let obj = {
        onlyFields: true
    }
    this.api.filterEmployees(obj).then((res: any) => {
        this.apiQueue = false;
        if (res.status == 'success') {
            this.fieldLists = res.fields;
            console.log(this.fieldLists);
        }
    }).catch((err) => {
        this.apiQueue = false;
        console.log(err)
    })
}

  getMemberInfo() {

    this.apiQueue = true;
    // console.log('searchEmployees', this.searchEmployees)
    let obj = {
        orgID: this.userData.orgID, /// <<<<< restrict ORG ID Important
        //projection: this.searchFields.map((item) => { let tmp = {}; tmp[item.name] = 1; return tmp; }),
        page: this.page
    };

    for(let k in this.searchEmployees) obj[k]=this.searchEmployees[k];

    this.api.filterEmployees(obj).then((res: any) => {
    this.apiQueue = false;
        if (res.status == 'success') {
            this.memberArray = res.data;
            if (this.memberArray.length === 0) this.noRecords = true;
            else this.noRecords = false;

              let empIDs = Object.keys(this.selectedRefId);
              this.memberArray.filter((member)=>{
                   if(empIDs.indexOf(member[this.recordRefId])!=-1){
                            this.selectedRecords[member[this.recordRefId]]= member;
                   }
              });
            // get shiftwise employee list
        }
    }).catch((err) => {
        this.apiQueue = false;
        console.log(err)
    })
  }
  selectionChange(refId, record) {
    if (this.selectedRecords[refId]) delete this.selectedRecords[refId];
    else this.selectedRecords[refId] = record;

}

toggleSelection() {
    if (this.selectAllCheckbox) {
        this.selectedRecords = {};
        this.selectAllCheckbox = false;
    } else {
        this.memberArray.length > 0 && this.memberArray.map((record) => {
            if (this.selectedRefId[record[this.recordRefId]] === undefined) {
                this.selectedRecords[record[this.recordRefId]] = record;
            }
        });
        this.selectAllCheckbox = true;
    }
}

submitRecords() {
    this.result.emit(this.selectedRecords);
}

  
selectionFromSearchAction() {
  this.selectedEmployee.emit(this.searchEmployees);
}

  mapSearchFind(location) {

    clearTimeout(this.mapSearchDebounceTimeOut);

    this.mapSearchDebounceTimeOut = setTimeout(() => {

        this.mapService.geoCoding(location).then((locations: any) => {
            this.mapSearchDataLists = [];
            this.mapSearchDataLists = locations.map((item) => {
                const lat = item['center'][1];
                const lng = item['center'][0];
                return {
                    name: item['name'] + ' lat,lng ' + lat + ',' + lng
                }
            });
        }).catch((error) => {
            console.log(error)
        });


    }, 600);

  }

  isNumber(evt) {
    if ((evt.target.value.split('.')).length > 2) {
        evt.target.value = evt.target.value.slice(0, -1);
        return false;
    }
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    //    console.log(charCode) 
    if (charCode === 46) return true;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
  
  fieldsSelected(e){
    console.log('fields',e);
    this.searchFields = e;
  }
  getEmployeeInfo(){
    console.log('emp info');
  }

}
